import React from 'react';
import { Modal, Box, Typography, Button, TextareaAutosize } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40vw',
  maxWidth: '580px',
  height: 'auto',
  bgcolor: '#FBFCFE',
  boxShadow: '0px 2px 24px 8px #005CBC1F',
  padding: '32px 24px 24px 24px',
  border: '10px solid #D7E5F8',
  borderRadius: '8px'
};

const ConfirmationModal = ({
  open,
  title,
  text,
  cancelText,
  SubmitText,
  onClose,
  onSubmit,
  textAlign = 'center',
  showTextArea = false,
  handleChange,
  isSteeringRecoCompleted,
  message = null,
  descriptionText = null
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby={title} aria-describedby={text}>
      <Box sx={style}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: textAlign,
              gap: '8px'
            }}>
            <Typography variant="h5">{title}</Typography>
            <Typography variant="body2" sx={{ color: '#3A3A3A' }}>
              {text}
              <p style={{ margin: '0px', textAlign: 'center' }}>{descriptionText}</p>
            </Typography>
            {showTextArea && (
              <TextareaAutosize
                id="description"
                placeholder="Type here"
                value={message}
                onChange={(event) => handleChange(event.target.value)}
                rows={4}
                style={{
                  width: '100%',
                  minHeight: '124px',
                  resize: 'both',
                  boxSizing: 'border-box',
                  borderColor: 'rgba(192, 192, 192, 1)'
                }}
              />
            )}
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '8px',
                padding: '8px'
              }}>
              {cancelText && (
                <Button
                  variant="outlined"
                  onClick={onClose}
                  data-testid="confirmation-modal-cancel-btn">
                  {cancelText}
                </Button>
              )}
              <Button
                data-testid="submit-button"
                variant="contained"
                color="primary"
                onClick={onSubmit}
                disabled={isSteeringRecoCompleted && SubmitText === 'Delete' ? true : false}>
                {SubmitText}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
